import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderListComponent } from './order-list/order-list.component';
import { OrdersRoutingModule } from './orders-routing.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { OrderComponent } from './order/order.component';
import { MatBadgeModule } from '@angular/material/badge';
import { MatChipsModule } from '@angular/material/chips';

@NgModule({
    imports: [
    CommonModule,
    OrdersRoutingModule,
    MatBadgeModule,
    MatButtonModule,
    MatChipsModule,
    NgxSpinnerModule,
    MatIconModule,
    OrderListComponent,
    OrderComponent
]
})
export class OrdersModule { }
